// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { emailSchema } from '@/contact/utilities/contact-form-schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const createCustomerFormSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  domain: z.string().nullable(),
  isCustomer: z.boolean(),
  isSupplier: z.boolean(),
  billingAddress: z.string().nullable(),
  billingContact: z.object({
    name: z.string().nullable(),
    email: emailSchema,
    phone: z.string().nullable(),
  }),
});

export type CreateCustomerFormData = z.infer<typeof createCustomerFormSchema>;

export const createCustomerFormResolver = zodResolver(createCustomerFormSchema);

export const DEFAULT_BILLING_VALUES: Pick<
  CreateCustomerFormData,
  'billingAddress' | 'billingContact'
> = {
  billingAddress: null,
  billingContact: {
    name: null,
    email: null,
    phone: null,
  },
};
